import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import StudioShell from "@/components/StudioShell";
import { LogoUploader, LogoPlacement, SlidePreview } from "@/components/BrandLogo";
import { toast } from "sonner";

export { LogoOverlay } from "@/components/BrandLogo";

const TEXT_FIELDS = [
  ["studio_name","Studio Name"],["tagline","Tagline"],["primary_font","Primary Font"],["secondary_font","Secondary Font"],["contact","Contact Information"],["footer","Footer Text"],
];
const RATIOS = ["16:9","4:3","A4 Landscape"];

export default function BrandSettings() {
  const [b, setB] = useState(null);
  useEffect(() => { api.get("/brand-settings").then(r => setB(r.data)).catch(e => toast.error(apiError(e, "Could not load brand settings"))); }, []);
  if (!b) return <StudioShell><div className="p-12">Loading…</div></StudioShell>;

  const patch = (changes) => setB(prev => ({ ...prev, ...changes }));
  const save = async () => {
    try { await api.put("/brand-settings", b); toast.success("Studio brand saved"); } catch (e) { toast.error(apiError(e, "Save failed")); }
  };

  return (
    <StudioShell>
      <div className="px-6 sm:px-12 py-12 max-w-[1100px] mx-auto">
        <div className="eyebrow mb-3">Studio Brand</div>
        <h1 className="editorial-heading text-4xl sm:text-5xl mb-10">Presentation Brand Settings</h1>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-3 studio-card p-8 space-y-6">
            {TEXT_FIELDS.map(([k,l]) => (
              <label key={k} className="block">
                <div className="eyebrow mb-2">{l}</div>
                <input value={b[k]||""} onChange={e=>patch({ [k]: e.target.value })} className="w-full border-b border-stone-300 py-2 bg-transparent outline-none focus:border-black" data-testid={`brand-${k}`} />
              </label>
            ))}
            <div className="block">
              <div className="eyebrow mb-2">Default Page Ratio</div>
              <div className="flex gap-2">
                {RATIOS.map(r => (
                  <button key={r} onClick={()=>patch({ ratio: r })} data-testid={`brand-ratio-${r}`}
                    className={`px-4 py-2 text-sm border ${b.ratio===r?"bg-black text-white border-black":"border-stone-300"}`}>{r}</button>
                ))}
              </div>
            </div>
            <div className="pt-4">
              <button onClick={save} data-testid="brand-save-btn" className="px-6 py-3 bg-black text-white text-sm">Save Settings</button>
            </div>
          </div>

          <div className="lg:col-span-2 space-y-6">
            <div className="studio-card p-8 space-y-6">
              <LogoUploader logoUrl={b.logo_url} onChange={(logo_url) => patch({ logo_url })} />
              <LogoPlacement brand={b} onChange={patch} />
            </div>
            <SlidePreview brand={b} />
          </div>
        </div>
      </div>
    </StudioShell>
  );
}
